import React, { useContext } from 'react';
import { Button } from 'antd';
import intl from 'react-intl-universal';
import { PayContext } from './ContextProvider';
import RoleList from './RoleList';
import './PaymentDlg.scss';
import SuccessIcon from '@/assets/PaymentDlg/success.svg';

const PayResSuccess = () => {
  const { isFree, close, lastSevenDay,store } = useContext(PayContext);

  const titleKey = isFree ? 'account.ActiveSevenTrail' : 'account.PayComplete';
  const title = intl.formatMessage({ id: titleKey });
  const btn = intl.formatMessage({ id: 'account.StartEditor' });

  const FreeTrailItem = intl.formatMessage({ id: 'account.FreeTrailItem' });
  const FreeTrailItemTip1 = intl.formatMessage(
    { id: 'account.FreeTrailItemTip1' });
  const FreeTrailItemTip2 = intl.formatMessage(
    { id: 'account.FreeTrailItemTip2' }, { time: lastSevenDay });

  const getTip = () => {
    if (isFree) {
      return (
        <>
          <p className='suc-tip-title pl180'>{FreeTrailItem}</p>
          <ul>
            <li>{FreeTrailItemTip1}</li>
            <li>{FreeTrailItemTip2}</li>
          </ul>
        </>
      );
    } else {
      return (
        <RoleList></RoleList>
      );
    }
  };

  return (
    <div className='pay-res-box'>
      <img src={SuccessIcon} />
      <h6>{title}</h6>
      {getTip()}
      <br />
      <Button onClick={() => {
        close();
        store.accountStore.getSubscribeStateNow();
      }}>{btn}</Button>
    </div>
  );
};
export default PayResSuccess;